
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Cookie, Shield, Eye } from 'lucide-react';
import { useConsentManager } from '@/hooks/useConsentManager';

export const ConsentBanner: React.FC = () => {
  const { gdprSettings, acceptAll, showBanner } = useConsentManager();

  // Don't render if banner shouldn't be shown
  if (!showBanner || !gdprSettings) return null;

  const handleAcceptAll = async () => {
    console.log('Got it clicked - accepting all cookies');
    await acceptAll();
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom-full duration-300">
      <Card className="w-full max-w-4xl mx-auto p-6 shadow-2xl border-0 bg-white backdrop-blur-md rounded-xl">
        <div className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
            <Cookie className="w-6 h-6 text-white" />
          </div>
          
          <div className="flex-1 space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                We value your privacy
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                {gdprSettings.consent_banner_text || 'We use cookies and similar technologies to provide the best experience on our website. By continuing to use our site, you consent to our use of cookies.'}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
              <div className="flex flex-wrap gap-3 text-sm">
                {gdprSettings.privacy_policy_url && (
                  <a 
                    href={gdprSettings.privacy_policy_url} 
                    className="text-blue-600 hover:text-blue-800 hover:underline flex items-center space-x-1 transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Shield className="w-3 h-3" />
                    <span>Privacy Policy</span>
                  </a>
                )}
                {gdprSettings.cookie_policy_url && (
                  <a 
                    href={gdprSettings.cookie_policy_url}
                    className="text-blue-600 hover:text-blue-800 hover:underline flex items-center space-x-1 transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Eye className="w-3 h-3" />
                    <span>Cookie Policy</span>
                  </a>
                )}
              </div>

              <Button
                onClick={handleAcceptAll}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 text-sm font-medium shadow-lg hover:shadow-xl transition-all duration-200"
              >
                Got it
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
